import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/misyonumuz",
      name: "misyonumuz",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Misyonumuz.vue")
    },
    {
      path: "/vizyonumuz",
      name: "vizyonumuz",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Vizyonumuz.vue")
    },
    {
      path: "/tarihce",
      name: "tarihce",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Tarihce.vue")
    },
    {
      path: "/weps",
      name: "weps",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Weps.vue")
    },
    {
      path: "/uyeler",
      name: "uyeler",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Uyeler.vue")
    },
    {
      path: "/neler-yaptik",
      name: "neler-yaptik",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/NelerYaptik.vue")
    },
    {
      path: "/strateji",
      name: "strateji",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Strateji.vue")
    },
    {
      path: "/iyi-uygulamalar",
      name: "iyi-uygulamalar",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/IyiUygulamalar.vue")
    },
    ,
    {
      path: "/arastirmalar",
      name: "arastirmalar",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Arastirmalar.vue")
    },
    {
      path: "/:catchAll(.*)",
      component: () => import("./views/404.vue")
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

export default router;

function getRoutesList(routes, pre) {
  return routes.reduce((array, route) => {
    const path = `${pre}${route.path}`;

    if (route.path !== "*") {
      array.push(path);
    }

    if (route.children) {
      array.push(...getRoutesList(route.children, `${path}/`));
    }

    return array;
  }, []);
}

function getRoutesXML() {
  const list = getRoutesList(
    router.options.routes,
    "https://birliktegucluyuz.org"
  )
    .map(route => `<url><loc>${route}</loc></url>`)
    .join("\r\n");
  return `<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.sitemaps.org/schemas/sitemap/0.9 http://www.sitemaps.org/schemas/sitemap/0.9/sitemap.xsd">
    ${list}
  </urlset>`;
}
console.log(getRoutesXML());
